import React, { Component } from 'react';
import * as PropTypes from 'prop-types';

import Modal from 'components/Modal';
import Button from 'components/Button';
import errorMessage from 'constants/errorMessages';

export class ErrorCardPopup extends Component {
  static propTypes = {
    onOk: PropTypes.func.isRequired,
  };

  handleOkClick = (e) => {
    e.preventDefault();

    const { onOk } = this.props;

    if (typeof onOk === 'function') {
      onOk();
    }
  };

  render() {
    return (
      <Modal showModal={true} hasCloseIcon={false}>
        {errorMessage.defaultServerError}

        <div className={'form form_buttons right'}>
          <Button type={'button'} color={'orange'} hasWrapper={false} onClick={this.handleOkClick}>
            {'Ок'}
          </Button>
        </div>
      </Modal>
    );
  }
}
